
export function cleanItemsForPrefill(items) {
    let list = []

    items.forEach(item => {
        let object = {...item}
        object['price'] = (item.itemCostCents).toFixed(2) / 100
        list.push(object)
    })

    return list
}